// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"8708":"3443ba80","9189":"c2d0105f"}[chunkId] + ".chunk.css";
};